import React, { useState , useEffect} from 'react';
import { quote,deployLiquidity,quoteMintLiquidity } from '../../functions/dexfunctions'
import { popupManager } from '../common/PopupManager';
export default function AddLiquidity({reserve,tokenAddress,signer,balance,dataToken,chain,transactionPath}) {
  const [ethAmount, setEthAmount] = useState('');
  const [tokenAmount, setTokenAmount] = useState('');
  const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
  const symbolNative = "ETH";
  const [loadingQuote,setloadingQuote] = useState(false)
  const [LPtokensOut,setLPtokensOut] = useState(0)
  function chainParamToChainId(chainParam) {
    switch (chainParam) {
      case "ethereum":
        return 1;
      // add more if needed
      default:
        return null; // or 1 as a default
    }
  }
    useEffect(() => {
      if (!signer) return;
  
      const requiredChainId = chainParamToChainId(chain);
  
      // If we don't have a mapping, you might handle that differently
      if (!requiredChainId) return;
  
      (async () => {
        try {
          // Ethers.js v6 returns an object with .chainId
          const network = await signer.provider.getNetwork();
          const currentChainId = Number(network.chainId);
  
          if (currentChainId !== requiredChainId) {
            popupManager.addPopup({
              id: Date.now(),
              type: "error",
              message: "Please connect your wallet to the selected network!",
              duration: 6000,
            });
          }
        } catch (err) {
          console.error("Error checking network:", err);
        }
      })();
    }, [signer, chain]);
  const handleEthChange = (e) => {

    const value = e.target.value;
    setEthAmount(value);
    
    const tokens = quote(value,reserve[0],reserve[1])
    getLpTokensOut(value,tokens)
    setTokenAmount(tokens);
  };

  const handleTokenChange = (e) => {
    const value = e.target.value;
    setTokenAmount(value);

    const eth = quote(value,reserve[1],reserve[0])
    setEthAmount(eth);
    getLpTokensOut(eth,value)

  };
  const getLpTokensOut = async (ethAmount,tokenAmount) => {
    setloadingQuote(true)
    const tokensout = await quoteMintLiquidity(ethAddress,tokenAddress,Math.round(ethAmount*10**10)/(10**10),tokenAmount,signer,chain)
   console.log(tokensout)
    setLPtokensOut(tokensout)
    setloadingQuote(false)

  }
  const deploy = async () => {
    let id = Date.now();
    try{
    if (!signer) {
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "Please connect your wallet before buying tokens.",
        duration: 6000,
      });
      return;
    }
    const network = await signer.provider.getNetwork();
    const chainId = Number(network.chainId);
    const requiredChainId = chainParamToChainId(chain);
    if (chainId !== requiredChainId) {
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: "Please connect your wallet to the selected network!",
        duration: 6000,
      });
      return;
    }
    console.log(tokenAmount)
    popupManager.addPopup({
      id: id,
      type: "message",
      message: `Adding ${ethAmount} ${symbolNative} and ${tokenAmount} Tokens of Liquidity`,
    });
    
    const resp = await deployLiquidity(
        ethAddress,
        tokenAddress,
        (Math.round(parseFloat(ethAmount)*1000000)/1000000).toString(),
        (Math.round(parseFloat(tokenAmount)*1000000)/1000000).toString(),
        (Math.round(parseFloat(ethAmount) * 0.95 * 1000000) / 1000000).toString(),
        (Math.round(parseFloat(tokenAmount) * 0.95 * 1000000) / 1000000).toString(),
        signer,
        ethAddress,
        chain
    )
      popupManager.removePopup(id);
      let successful_id = Date.now();

      popupManager.addPopup({
        id: successful_id,
        type: "success",
        message:
          "Transaction sent!",
      });
      setEthAmount(0);
      setTokenAmount(0);
    }catch(e){
      popupManager.removePopup(id);
      console.log(e)
      popupManager.addPopup({
        id: Date.now(),
        type: "error",
        message: typeof e === 'string' ? e : e.toString(),
        duration: 6000,
      });
    }
    
  }
  return (
    <div className="py-0 rounded-lg shadow-sm w-full mx-auto">
      <form>
        <div className="mb-4">
          <label className="block text-start text-[13px] text-gray-300 font-[500] kanit-light mb-2" htmlFor="ethAmount">
            {symbolNative} Amount
          </label>
          <input
            type="number"
            id="ethAmount"
            value={ethAmount}
            onWheel={e => e.target.blur()}  
            onChange={handleEthChange}
            placeholder={symbolNative}
            className="w-full p-2 py-4  text-[13px] border border-white/15 text-gray-300 rounded-md bg-transparent focus:outline-none  "
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-300 text-[13px] text-start font-medium mb-2" htmlFor="tokenAmount">
            {dataToken.symbol} Amount
          </label>
          <input
            type="number"
            id="tokenAmount"
            value={tokenAmount}
            onWheel={e => e.target.blur()}  
            onChange={handleTokenChange}
            placeholder="Token"
            className="w-full p-2 py-4 text-[13px] text-gray-300  border border-white/15 rounded-md bg-transparent focus:outline-none"
          />
        </div>
        <div className='h-[1px] bg-white/10 w-full mt-4'></div>
        {loadingQuote === true ? 
        <div className='h-6 animate-pulse bg-white/5 mt-3 mb-4'></div>
        :
        <div className='h-6  noto-sans-display text-[#7b7f8f] text-[13px] font-[400] text-start mt-3 mb-4'>You will get {Math.round(LPtokensOut*1000000000)/1000000000} LP Tokens</div> 
        }
        {(balance[0] < tokenAmount || balance[1] < ethAmount)?
            <button
            disabled
                type="button"
                className="w-full text-white/50 bg-white/5 border border-white/10 py-2 rounded-xl font-semibold transition duration-300 mb-2"
                >
                Not enough Balance
            </button>
            :
            <button
            type="button"
            className="w-full text-[16px] font-[600] text-white bg-gradient-to-r from-[#faffbfb5] via-[#c3c17e] to-[#faffbfb5] hover:brightness-110 border border-white/60 hover:border-white/90 transition duration-300 py-2 px-4 rounded-xl focus:outline-none"
            onClick={deploy}
            >
            Add 
            </button>        
        }

        {/* Transaction Path Indicator */}
        {signer && transactionPath && (
          <div className="mt-4 mb-2 p-3 bg-white/5 border border-white/10 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <svg className="w-4 h-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="text-white/80 text-sm font-medium">Transaction Path</span>
            </div>
            <div className="space-y-1">
              {transactionPath.map((step, index) => (
                <div key={index} className="flex items-center gap-2 text-white/70 text-xs">
                  <div className="w-2 h-2 bg-yellow-400 rounded-full"></div>
                  <span>{step}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        
      </form>
    </div>
  );
}
